import MIcon from './MIcon.vue';

MIcon.install = (app) => {
  app.component('MIcon', MIcon);
};

export { MIcon };
